<div class="aca-admin aca-audit">
  <aca-page-header [bare]="embedded" icon="fact_check" [title]="'DMS.AUDIT_LOG.F7DBD8' | translate" [subtitle]="'DMS.UI.D090BE' | translate">
    <button type="button" class="aca-audit__outline" (click)="reload()" [disabled]="loading">
      <mat-icon>refresh</mat-icon>{{ 'DMS.AUDIT_LOG.78A47D' | translate }}
    </button>
    <button type="button" class="aca-audit__outline" (click)="exportExcel()" [disabled]="!entries.length">
      <mat-icon>download</mat-icon>{{ 'DMS.AUDIT_LOG.7E1816' | translate }}
    </button>
  </aca-page-header>

  <!-- ── summary ────────────────────────────────────────────────────────── -->
  <div class="aca-audit__stats">
    <div class="aca-audit__stat">
      <span class="aca-audit__staticon aca-audit__staticon--blue"><mat-icon>receipt_long</mat-icon></span>
      <span class="aca-audit__stattext">
        <span class="aca-audit__statlabel">{{ 'DMS.AUDIT_LOG.220A11' | translate }}</span>
        <span class="aca-audit__statvalue">{{ entries.length | number }}</span>
        <span class="aca-audit__statunit">{{ 'DMS.AUDIT_LOG.51C19F' | translate }}</span>
      </span>
    </div>
    <div class="aca-audit__stat">
      <span class="aca-audit__staticon aca-audit__staticon--purple"><mat-icon>apps</mat-icon></span>
      <span class="aca-audit__stattext">
        <span class="aca-audit__statlabel">{{ 'DMS.AUDIT_LOG.258871' | translate }}</span>
        <span class="aca-audit__statvalue">{{ apps.length | number }}</span>
        <span class="aca-audit__statunit">{{ 'DMS.AUDIT_LOG.77C348' | translate }}</span>
      </span>
    </div>
    <div class="aca-audit__stat">
      <span class="aca-audit__staticon aca-audit__staticon--green"><mat-icon>toggle_on</mat-icon></span>
      <span class="aca-audit__stattext">
        <span class="aca-audit__statlabel">{{ 'DMS.AUDIT_LOG.E77C7A' | translate }}</span>
        <span class="aca-audit__statvalue">{{ enabledApps.length | number }}</span>
        <span class="aca-audit__statunit">{{ 'DMS.AUDIT_LOG.77C348' | translate }}</span>
      </span>
    </div>
    <div class="aca-audit__stat">
      <span class="aca-audit__staticon aca-audit__staticon--amber"><mat-icon>filter_alt</mat-icon></span>
      <span class="aca-audit__stattext">
        <span class="aca-audit__statlabel">{{ 'DMS.AUDIT_LOG.137308' | translate }}</span>
        <span class="aca-audit__statvalue">{{ filteredEntries().length | number }}</span>
        <span class="aca-audit__statunit">{{ 'DMS.AUDIT_LOG.51C19F' | translate }}</span>
      </span>
    </div>
  </div>

  <!-- ── audit applications ─────────────────────────────────────────────── -->
  <div class="aca-audit__apps" *ngIf="apps.length">
    <span class="aca-audit__appslabel">{{ 'DMS.AUDIT_LOG.AC7625' | translate }}</span>
    <button
      type="button"
      class="aca-audit__appchip"
      *ngFor="let app of apps"
      [class.aca-audit__appchip--on]="app.id === activeApp"
      [disabled]="!app.isEnabled"
      (click)="selectApp(app.id)"
    >
      {{ app.name || app.id }}
      <span class="aca-audit__appstate" [ngClass]="app.isEnabled ? 'aca-audit__appstate--on' : 'aca-audit__appstate--off'">
        {{ app.isEnabled ? ('DMS.UI.06314A' | translate) : ('DMS.UI.1B6D61' | translate) }}
      </span>
    </button>
  </div>

  <!-- ── filters ────────────────────────────────────────────────────────── -->
  <div class="aca-audit__filterbar">
    <label class="aca-audit__searchfilter">
      <mat-icon>search</mat-icon>
      <input type="text" [(ngModel)]="searchText" [placeholder]="'DMS.AUDIT_LOG.66D618' | translate" autocomplete="off" />
    </label>

    <label class="aca-audit__filter">
      <span class="aca-audit__filterlabel">{{ 'DMS.AUDIT_LOG.9C5893' | translate }}</span>
      <aca-date-input
        class="aca-audit__date"
        [(ngModel)]="dateFrom"
        (ngModelChange)="datesChanged()"
        [ariaLabel]="'DMS.AUDIT_LOG.1FD6D1' | translate"
      />
    </label>

    <label class="aca-audit__filter">
      <span class="aca-audit__filterlabel">{{ 'DMS.AUDIT_LOG.21F6F4' | translate }}</span>
      <aca-date-input
        class="aca-audit__date"
        [(ngModel)]="dateTo"
        (ngModelChange)="datesChanged()"
        [ariaLabel]="'DMS.AUDIT_LOG.B3174D' | translate"
      />
    </label>

    <button type="button" class="aca-audit__link" (click)="clearFilters()">{{ 'DMS.AUDIT_LOG.1C5830' | translate }}</button>
  </div>

  <!-- ── nothing recorded ───────────────────────────────────────────────── -->
  <div class="aca-audit__unavailable" *ngIf="auditProducesNothing">
    <mat-icon>info</mat-icon>
    <div>
      <p>
        <strong>{{ 'DMS.AUDIT_LOG.CDF400' | translate }}</strong>
      </p>
      <p>
        {{ 'DMS.AUDIT_LOG.98E97F' | translate }}<code>tagging</code>{{ 'DMS.AUDIT_LOG.1963AD' | translate }}<code>alfresco-access</code
        >{{ 'DMS.AUDIT_LOG.561FEC' | translate }}<strong>{{ 'DMS.AUDIT_LOG.86AA5E' | translate }}</strong
        >{{ 'DMS.AUDIT_LOG.40146C' | translate }}
      </p>
      <p>{{ 'DMS.AUDIT_LOG.BCAEA6' | translate }}<code>alfresco-global.properties</code>{{ 'DMS.AUDIT_LOG.4E09DB' | translate }}</p>
      <pre class="aca-audit__code">
audit.enabled=true
audit.alfresco-access.enabled=true
audit.tagging.enabled=true</pre
      >
      <p>{{ 'DMS.AUDIT_LOG.79D68F' | translate }}</p>
    </div>
  </div>

  <!-- ── table + detail ─────────────────────────────────────────────────── -->
  <div class="aca-audit__body" *ngIf="!auditProducesNothing" [class.aca-audit__body--split]="selected">
    <section class="aca-audit__card">
      <div class="aca-audit__tablewrap">
        <table class="aca-audit__table">
          <thead>
            <tr>
              <th class="aca-audit__th">{{ 'DMS.AUDIT_LOG.7A2292' | translate }}</th>
              <th class="aca-audit__th">{{ 'DMS.AUDIT_LOG.0E026E' | translate }}</th>
              <th class="aca-audit__th">{{ 'DMS.AUDIT_LOG.F16D74' | translate }}</th>
              <th class="aca-audit__th aca-audit__th--summary">{{ 'DMS.AUDIT_LOG.74E19E' | translate }}</th>
              <th class="aca-audit__th aca-audit__th--actions">{{ 'DMS.AUDIT_LOG.27EF78' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="aca-audit__row"
              *ngFor="let entry of filteredEntries(); trackBy: trackById"
              [class.aca-audit__row--on]="selected?.id === entry.id"
            >
              <td class="aca-audit__td">{{ (entry.createdAt | acaDate: 'd MMM y HH:mm:ss') || '—' }}</td>
              <td class="aca-audit__td">
                <span class="aca-audit__user">
                  <span class="aca-audit__avatar">{{ initial(actorOf(entry)) }}</span
                  >{{ actorOf(entry) }}
                </span>
              </td>
              <td class="aca-audit__td">
                <span class="aca-audit__chip">{{ appName(entry.auditApplicationId || activeApp) }}</span>
              </td>
              <td class="aca-audit__td aca-audit__td--summary">{{ summarise(entry) }}</td>
              <td class="aca-audit__td aca-audit__td--actions">
                <button
                  mat-icon-button
                  (click)="select(entry)"
                  [matTooltip]="'DMS.AUDIT_LOG.FF9D41' | translate"
                  [attr.aria-label]="'DMS.AUDIT_LOG.FF9D41' | translate"
                >
                  <mat-icon>info</mat-icon>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="aca-audit__pager" *ngIf="pageIndex > 0 || hasMore">
        <span>{{ 'DMS.AUDIT_LOG.PAGE_RANGE' | translate: pageRange }}</span>
        <button mat-icon-button (click)="previousPage()" [disabled]="loading || pageIndex === 0" [attr.aria-label]="'DMS.AUDIT_LOG.PREV' | translate">
          <mat-icon>chevron_left</mat-icon>
        </button>
        <button mat-icon-button (click)="nextPage()" [disabled]="loading || !hasMore" [attr.aria-label]="'DMS.AUDIT_LOG.NEXT' | translate">
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>
    </section>

    <aside class="aca-audit__panel" *ngIf="selected as entry">
      <div class="aca-audit__panelhead">
        <h3 class="aca-audit__paneltitle">{{ 'DMS.AUDIT_LOG.BD3A34' | translate }}</h3>
        <button
          mat-icon-button
          (click)="select(null)"
          [matTooltip]="'DMS.AUDIT_LOG.96D79D' | translate"
          [attr.aria-label]="'DMS.AUDIT_LOG.96D79D' | translate"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <dl class="aca-audit__props">
        <dt>{{ 'DMS.AUDIT_LOG.D815CF' | translate }}</dt>
        <dd>{{ entry.id }}</dd>

        <dt>{{ 'DMS.AUDIT_LOG.7A2292' | translate }}</dt>
        <dd>{{ (entry.createdAt | acaDate: 'd MMMM y HH:mm:ss') || '—' }}</dd>

        <dt>{{ 'DMS.AUDIT_LOG.0E026E' | translate }}</dt>
        <dd>{{ actorOf(entry) }}</dd>

        <dt>{{ 'DMS.AUDIT_LOG.F16D74' | translate }}</dt>
        <dd>{{ appName(entry.auditApplicationId || activeApp) }}</dd>
      </dl>

      <ng-container *ngIf="valueRows(entry).length">
        <h4 class="aca-audit__section">{{ 'DMS.AUDIT_LOG.9E54F4' | translate }}</h4>
        <dl class="aca-audit__props">
          <ng-container *ngFor="let row of valueRows(entry)">
            <dt>{{ row.key }}</dt>
            <dd>{{ row.value }}</dd>
          </ng-container>
        </dl>
      </ng-container>

      <h4 class="aca-audit__section">Metadata (JSON)</h4>
      <pre class="aca-audit__json">{{ metadataJson(entry) }}</pre>
    </aside>
  </div>
</div>
